import { cn } from '@seen/ui'
import { IconTrash } from '@tabler/icons-react'
import type { JSX } from 'react'
import {
  DropdownMenuItem,
  type DropdownMenuItemProps,
} from '#src/components/core/dropdown-menu/DropdownMenuItem.tsx'
import {
  type DeleteConfirmationProps,
  useDeleteConfirmationStore,
} from '#src/hooks/useDeleteConfirmationStore.ts'

interface DropdownMenuDeleteItemProps extends Omit<
  DropdownMenuItemProps,
  'onSelect' | 'children'
> {
  deleteConfirmationProps: DeleteConfirmationProps
}

export function DropdownMenuDeleteItem({
  deleteConfirmationProps,
  className,
  ...delegated
}: DropdownMenuDeleteItemProps): JSX.Element {
  const open = useDeleteConfirmationStore((state) => state.open)
  return (
    <DropdownMenuItem
      className={cn('flex items-center gap-2', className)}
      onSelect={() => {
        open(deleteConfirmationProps)
      }}
      {...delegated}
    >
      <IconTrash className="-mt-px size-4 text-foreground-secondary" />
      Delete…
    </DropdownMenuItem>
  )
}
